import {
  Box,
  Button,
  Flex,
  Heading,
  Text,
} from "@chakra-ui/react";
import { Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useEffect, useState } from "react";
import { Avatar } from "../../components/Avatar";
import { Filter } from "../../components/Filter";
import WithAuth from "../../hoc/withAuth";
import { useTransfer } from "../../hooks/useTransfer";
import { Balance } from "../../models/Transfer";
import { MinusCircle } from "../../styles/icons/MinusCircle";
import { PlusCircle } from "../../styles/icons/PlusCircle";
import { formatCurrency, showToast, useUserInfo } from "../../utils";
import { OperationModal } from "./_OperationModal";
import { registerLocale } from "react-datepicker";
import ptBR from "date-fns/locale/pt-BR"

export function Transfer() {
  const [transfers, setTransfers] = useState<Balance[]>([]);
  const [filteredTransfers, setFilteredTransfers] = useState<Balance[]>([]);
  const [isOperationModalOpen, setIsOperationModalOpen] = useState(false);
  const [chooseType, setChooseType] = useState("");
  const [chooseSeller, setChooseSeller] = useState<Balance>({} as Balance);
  const { roles } = useUserInfo();

  const { getTansfers } = useTransfer();
  registerLocale("ptBR", ptBR);

  const amountColumns: ColumnsType<Balance> = [
    {
      key: "sellerName",
      title: "Seller",
      dataIndex: "sellerName",
      render: (sellerAccountancy, record) => (
        <Text>
          <Avatar name={record?.sellerAccountancy?.sellerName} />
        </Text>
      )
    },
    {
      key: "pixKey",
      title: "PIX",
      dataIndex: "pixKey",
      render: (pixKey, record) => (
        <Text>{record?.sellerAccountancy?.pixKey}</Text>
      )
    },
    {
      key: "amount",
      title: "Saldo",
      dataIndex: "amount",
      render: (amount) => (
        <Text >{formatCurrency({ value: amount })}</Text>
      )
    },
    {
      key: "",
      title: "",
      dataIndex: "",
      render: (record) => (
        roles?.includes("BARTE_BALANCE_CORRECTION") && (
          <Flex gap="2">
            <Button
              maxH="24px"
              maxW="80px"
              fontSize="14px"
              borderRadius="3"
              bgColor="white"
              color="dustred.200"
              border="1px solid"
              onClick={() => handleOperationModal(record, "DEBIT")}
              p="2"
              _hover={{
                bgColor: "dustred.100"
              }}
            >
              <Flex justify="center" align="center" gap="1">
                <MinusCircle
                  color="#FF4D4F"
                  size={15}
                />
                <Text color="black" fontWeight={400}>Débito</Text>
              </Flex>
            </Button>
            <Button
              maxH="24px"
              maxW="80px"
              fontSize="14px"
              borderRadius="3"
              bgColor="white"
              color="polargreen.300"
              border="1px solid"
              onClick={() => handleOperationModal(record, "CREDIT")}
              p="2"
              _hover={{
                bgColor: "polargreen.100"
              }}
            >
              <Flex justify="center" align="center" gap="1">
                <PlusCircle
                  color="#52C41A"
                  size={15}
                />
                <Text color="black" fontWeight={400}>Crédito</Text>
              </Flex>
            </Button>
          </Flex>
        )
      )
    }
  ]
  function filterTable(searchParam: string) {
    setFilteredTransfers(transfers.filter(transfer => transfer.sellerAccountancy?.sellerName?.toLowerCase().includes(searchParam.toLowerCase())));

  }

  async function handleGetInitialData(searchParam?: string) {


    try {
      const {data} = await getTansfers({companyName: searchParam ?? ""},{size: 10000, }
      );

      const formattedData = data.content.map((data: Balance, index: number) => {
        return {
          ...data,
          key: index
        }
      })
      setTransfers(formattedData);
    } catch (error: any) {
      error?.response?.data?.errors?.map((error: any) => (
        showToast({
          type: "error",
          message: `${error?.code} - ${error?.description}`
        })
      ));
    }
  }
  async function onCloseOperationModal() {
    setChooseSeller({} as Balance);
    setChooseType("");
    setIsOperationModalOpen(false);
  }
  async function handleOperationModal(seller: Balance, type: string) {
    setChooseSeller(seller);
    setChooseType(type);
    setIsOperationModalOpen(!isOperationModalOpen);
  }

  useEffect(() => {
    handleGetInitialData();
    // eslint-disable-next-line
  }, [isOperationModalOpen]);


  return (
    <Box 
      letterSpacing="tighter"
    >
      <OperationModal
        isOpen={isOperationModalOpen}
        onClose={onCloseOperationModal}
        type={chooseType}
        seller={chooseSeller}
      />
      <Flex
        flexDir="column"
      >
        <Heading marginBottom="2rem">Saldo</Heading>
        <Filter placeholder="Buscar seller"
          filterTable={filterTable}
          onSubmitSearch={handleGetInitialData}
          needToSubmit
        />
        <Table<Balance>
          columns={amountColumns}
          dataSource={
            filteredTransfers?.length > 0
              ? filteredTransfers
              : transfers
          }
          rowKey={(record) => record.key}
          locale={{ emptyText: "Sem repasses cadastrados" }}
        />
      </Flex>
    </Box>
  );
}

export default WithAuth(Transfer);